import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccessDark = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 140,
	viewBox: "0 0 412 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 82.1002,
			y1: 60.6208,
			x2: 17.1002,
			y2: 75.6208,
			stroke: "#686869",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 95.3514,
			y1: 63.9015,
			x2: 111.351,
			y2: 83.9015,
			stroke: "#686869",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 122.816,
			y1: 86.7718,
			x2: 178.816,
			y2: 61.6614,
			stroke: "#686869",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 85.1831C13.4183 85.1831 17 81.6014 17 77.1831C17 72.7648 13.4183 69.1831 8.99999 69.1831C4.58171 69.1831 1 72.7648 1 77.1831C1 81.6014 4.58171 85.1831 8.99999 85.1831Z",
			stroke: "#686869",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.00048 80.1824C10.6573 80.1824 12.0005 78.8392 12.0005 77.1824C12.0005 75.5255 10.6573 74.1824 9.00048 74.1824C7.34362 74.1824 6.00049 75.5255 6.00049 77.1824C6.00049 78.8392 7.34362 80.1824 9.00048 80.1824Z",
			fill: "#C28D10"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.001 98.1831C120.419 98.1831 124.001 94.6014 124.001 90.1831C124.001 85.7648 120.419 82.1831 116.001 82.1831C111.583 82.1831 108.001 85.7648 108.001 90.1831C108.001 94.6014 111.583 98.1831 116.001 98.1831Z",
			stroke: "#686869",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.001 93.1836C117.658 93.1836 119.001 91.8404 119.001 90.1836C119.001 88.5267 117.658 87.1836 116.001 87.1836C114.345 87.1836 113.001 88.5267 113.001 90.1836C113.001 91.8404 114.345 93.1836 116.001 93.1836Z",
			fill: "#C28D10"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.999 66.1836C94.4173 66.1836 97.999 62.6019 97.999 58.1836C97.999 53.7653 94.4173 50.1836 89.999 50.1836C85.5807 50.1836 81.999 53.7653 81.999 58.1836C81.999 62.6019 85.5807 66.1836 89.999 66.1836Z",
			stroke: "#686869",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.9995 61.1841C91.6564 61.1841 92.9995 59.8409 92.9995 58.1841C92.9995 56.5272 91.6564 55.1841 89.9995 55.1841C88.3427 55.1841 86.9995 56.5272 86.9995 58.1841C86.9995 59.8409 88.3427 61.1841 89.9995 61.1841Z",
			fill: "#C28D10"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 284.604,
			y1: 28.9995,
			x2: 225.172,
			y2: 53.8892,
			stroke: "#686869",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 339.941,
			y1: 94.1378,
			x2: 394.94,
			y2: 87.1378,
			stroke: "#686869",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 297.394,
			y1: 31.3665,
			x2: 328.394,
			y2: 87.3665,
			stroke: "#686869",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M331.999 102.584C336.417 102.584 339.999 99.002 339.999 94.5837C339.999 90.1655 336.417 86.5837 331.999 86.5837C327.58 86.5837 323.999 90.1655 323.999 94.5837C323.999 99.002 327.58 102.584 331.999 102.584Z",
			stroke: "#686869",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M331.999 97.5842C333.656 97.5842 334.999 96.2411 334.999 94.5842C334.999 92.9274 333.656 91.5842 331.999 91.5842C330.342 91.5842 328.999 92.9274 328.999 94.5842C328.999 96.2411 330.342 97.5842 331.999 97.5842Z",
			fill: "#C28D10"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M402.999 94.5845C407.417 94.5845 410.999 91.0027 410.999 86.5845C410.999 82.1662 407.417 78.5845 402.999 78.5845C398.581 78.5845 394.999 82.1662 394.999 86.5845C394.999 91.0027 398.581 94.5845 402.999 94.5845Z",
			stroke: "#686869",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 89.585C404.656 89.585 406 88.2418 406 86.585C406 84.9281 404.656 83.585 403 83.585C401.343 83.585 400 84.9281 400 86.585C400 88.2418 401.343 89.585 403 89.585Z",
			fill: "#C28D10"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M291.997 33.5842C296.415 33.5842 299.997 30.0025 299.997 25.5842C299.997 21.166 296.415 17.5842 291.997 17.5842C287.578 17.5842 283.997 21.166 283.997 25.5842C283.997 30.0025 287.578 33.5842 291.997 33.5842Z",
			stroke: "#686869",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M291.997 28.5847C293.654 28.5847 294.997 27.2416 294.997 25.5847C294.997 23.9279 293.654 22.5847 291.997 22.5847C290.34 22.5847 288.997 23.9279 288.997 25.5847C288.997 27.2416 290.34 28.5847 291.997 28.5847Z",
			fill: "#C28D10"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M55.2987 104.665C55.2987 106.685 53.6687 108.315 51.6487 108.315C49.6287 108.315 47.9988 106.685 47.9988 104.665C47.9988 102.645 49.6287 101.015 51.6487 101.015C53.6687 101.015 55.2987 102.645 55.2987 104.665Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M370.655 43.8028C370.655 45.8228 369.025 47.4528 367.005 47.4528C364.985 47.4528 363.355 45.8228 363.355 43.8028C363.355 41.7828 364.985 40.1528 367.005 40.1528C369.025 40.1528 370.655 41.7828 370.655 43.8028Z",
			fill: "#D99E12"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.6527 11.3276C33.3894 11.3151 33.1261 11.3777 32.8879 11.5407C32.3237 11.9294 32.1732 12.6944 32.5619 13.2586L39.7839 23.8408C39.9971 24.1542 40.3481 24.3549 40.7243 24.38C41.0754 24.4176 41.4766 24.2545 41.7273 23.9787L46.3915 18.8506L54.7546 32.6928C54.9552 33.0188 55.2811 33.2319 55.6573 33.2821C56.0334 33.3197 56.4096 33.1943 56.6854 32.931L61.7634 27.878L63.0641 26.59C63.2251 26.2661 63.1802 25.5585 62.9796 25.2576C62.779 24.9567 62.4405 24.756 62.0769 24.7184C61.6882 24.6682 61.3497 24.8187 61.0864 25.0695L56.0711 30.0597L47.6704 16.1423C47.4698 15.8037 47.1188 15.5906 46.7301 15.553C46.3163 15.5029 45.9527 15.6658 45.6894 15.9542L40.9625 21.145L34.6307 11.8541C34.405 11.5282 34.0414 11.3402 33.6778 11.3151L33.6527 11.3276Z",
			fill: "#6BA984"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M303.843 102.857C304.106 102.844 304.369 102.907 304.607 103.07C305.172 103.458 305.322 104.223 304.933 104.788L297.711 115.37C297.498 115.683 297.147 115.884 296.771 115.909C296.42 115.947 296.019 115.784 295.768 115.508L291.104 110.38L282.741 124.222C282.54 124.548 282.214 124.761 281.838 124.811C281.462 124.849 281.086 124.723 280.81 124.46L275.732 119.407L274.431 118.119C274.27 117.795 274.315 117.088 274.516 116.787C274.716 116.486 275.055 116.285 275.419 116.247C275.807 116.197 276.146 116.348 276.409 116.599L281.424 121.589L289.825 107.671C290.026 107.333 290.377 107.12 290.765 107.082C291.179 107.032 291.543 107.195 291.806 107.483L296.533 112.674L302.865 103.383C303.09 103.057 303.454 102.869 303.818 102.844L303.843 102.857Z",
			fill: "#6BA984"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 150.205,
			y: 8.80737,
			width: 111.59,
			height: 111.59,
			rx: 24.0541,
			fill: "#F3B82C"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M151.977 103.513C153.013 107.595 154.649 110.753 157.231 113.335C164.276 120.38 175.615 120.38 198.294 120.38H213.668C236.346 120.38 247.685 120.38 254.73 113.335C261.776 106.29 261.776 94.9508 261.776 72.2724V56.8984C261.776 34.22 261.776 22.8808 254.73 15.8355C254.477 15.5819 254.218 15.3375 253.953 15.1018C255.744 22.1585 255.744 31.9749 255.744 46.3425V61.7165C255.744 84.3949 255.744 95.7341 248.699 102.779C241.654 109.825 230.314 109.825 207.636 109.825H192.262C170.4 109.825 159.076 109.825 151.977 103.513Z",
			fill: "#C28D10"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M227.183 48.2036L198.148 77.2395L183.63 62.7216",
			stroke: "#19191A",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSuccessDark);
export default ForwardRef;
